import React from 'react'
import { clone, cloneDeep } from 'lodash';
import styles from './styles'
import twemoji from 'twemoji'
import twitterText from 'twitter-text'

class Text extends React.Component {
  render () {
    let {data} = this.props
    let {full_text, extended_entities} = data;
    let text = clone(full_text);
    let entities = cloneDeep(data.entities || {});

    // remove any embedded media links
    if (entities && entities.media) {
      entities.media.forEach( e => {
        text = text.replace(e.url, '')
      })
    }

    // remove any quote links
    if (entities && entities.urls && data.is_quote_status) {
      entities.urls = entities.urls.filter( u => {
        if (u.expanded_url.indexOf('/status/') > -1) {
          text = text.replace(u.url, '')
          return false;
        }

        return true;
      })
    }

    // replace + style links and mentions
    text = twitterText.autoLinkWithJSON(text, (entities || {}), {'usernameIncludeSymbol': true, targetBlank: true})

    text = text.replace(/href=/g, 'style="text-decoration: none;color:#1da1f2;" href=');

    // replace + style emoji
    text = twemoji.parse(text)
    text = text.replace(/<img class="emoji"/g, '<img class="emoji" style="height:14px;margin-right:5px;"')
    // browsers add http which causes isomorphic rendering probs
    text = text.replace(/src="\/\/twemoji/g, 'src="http://twemoji')

    // remove any extended entities links
    if (extended_entities && extended_entities.media) {
      extended_entities.media.forEach(e => {
        text = text.replace(e.display_url, '')
      })
    }

    const tweetProps = {
      'className': 'tweet-text',
      'style': styles.tweetText,
      'dangerouslySetInnerHTML': {
        '__html': text
      }
    }

    return <p {... tweetProps} />
  }
}

export default Text